/* 🤖 this file was generated by script */
export const wiconDotsHorizontal02 = {
  name: 'dots_horizontal_02',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2.08" d="M10 10s0 0 0 0M6.25 10s0 0 0 0M13.75 10s0 0 0 0"/><circle cx="10" cy="10" r="8.33" fill="none" stroke="currentColor" stroke-width="1.39"/></svg>`,
};
